module.exports = __webpack_public_path__ + "img/comic-book-click.ad87d3a3.png";